import React, { useEffect } from "react";
import { ResponsivePie } from '@nivo/pie'
import { convertCost } from "../../../Utils/functions";

export const delvieryMockData = {//delivery data mockup
        "Price": 172200,
        "Count": 157,
        "Platform": {
            "Baemin": {
                "Price": 120244,
                "Count": 80
            },
            "Eats": {
                "Price": 42557,
                "Count": 57
            },
            "Yogiyo": {
                "Price": 20133,
                "Count": 20
            }
        }
    }

const DeliveryChart = ({info}) => {
    const [data,setData] = React.useState([])//delivery data

    //data parsing
    useEffect(() => {
        let newData = [{
            "id": "배달의 민족",
            "label": "배달의 민족",
            "value": info.Platform.Baemin.Price,
            "color" : '#4fc8c4'
          },
          {
            "id": "요기요",
            "label": "요기요",
            "value": info.Platform.Yogiyo.Price,
            "color": "#f00c5a"
          },
          {
            "id": "쿠팡잇츠",
            "label": "쿠팡잇츠",
            "value": info.Platform.Eats.Price,
            "color": "#f8c800"
        }]
        
        setData(newData)
    },[info])

    return (
        <div style={{ width : 412, height : 330 }}>
            <ResponsivePie
                data={data}
                margin={{ top: 80, right: 0, bottom: 0, left: 0 }}
                innerRadius={0.8}
                height={280}
                activeOuterRadiusOffset={8}
                borderColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            0.2
                        ]
                    ]
                }}
                colors={['#4fc8c4','#f00c5a','#f8c800']}
                enableArcLinkLabels={false}
                arcLinkLabelsSkipAngle={10}
                arcLinkLabelsTextColor="#333333"
                arcLinkLabelsThickness={2}
                arcLinkLabelsColor={{ from: 'color' }}
                enableArcLabels={false}
                arcLabelsSkipAngle={10}
                tooltip={(props) => {
                    return(
                        <div className='tooltip' style={{ flexDirection : 'column',alignItems : 'center', justifyContent : 'center',display : 'flex',backgroundColor : 'white', padding : 16, paddingTop : 16, paddingBottom : 1, borderRadius : 24, boxShadow : '0 12px 14px 0 rgba(0, 0, 0, 0.07)' }}>
                            {
                                Object.keys(props).length > 0 &&
                                <>
                                    <p style={{ fontSize : 12, fontWeight : 500, lineHeight : 1.5, color : '#3f3f3f'}}>{props.datum.id}</p>
                                    <p style={{ fontSize : 18, fontWeight : 'bold', lineHeight : 1.78, textAlign : 'center', color : props.datum.data.color}}>{convertCost(props.datum.value)} 원</p>
                                </>
                            }
                        </div>
                    )
                }}
                motionConfig="default"
                legends={[
                    {
                        anchor: 'top-left',
                        direction: 'column',
                        justify: false,
                        translateX: 0,
                        translateY: -64,
                        itemsSpacing: 8,
                        itemWidth: 56,
                        itemHeight: 16,
                        itemTextColor: '#999',
                        itemDirection: 'left-to-right',
                        itemOpacity: 1,
                        symbolSize: 8,
                        symbolShape: 'circle',
                        effects: [
                            {
                                on: 'hover',
                                style: {
                                    itemTextColor: '#000'
                                }
                            }
                        ]
                    }
                ]}
            />
        </div>
    )
}

export default DeliveryChart;